import { render, staticRenderFns } from "./ArchivedCampaigns.vue?vue&type=template&id=6255ea38&scoped=true&"
import script from "./ArchivedCampaigns.vue?vue&type=script&lang=js&"
export * from "./ArchivedCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCampaigns.vue?vue&type=style&index=0&id=6255ea38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6255ea38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VIcon,VPagination,VProgressCircular,VRow,VSelect,VSimpleTable})
